/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SaveJobTagRequest from './SaveJobTagRequest';

/**
 * The JobTagUpdateRequest model module.
 * @module model/JobTagUpdateRequest
 * @version V1
 */
class JobTagUpdateRequest {
    /**
     * Constructs a new <code>JobTagUpdateRequest</code>.
     * @alias module:model/JobTagUpdateRequest
     * @param jobTagId {Number} 
     * @param jobTagData {module:model/SaveJobTagRequest} 
     */
    constructor(jobTagId, jobTagData) { 
        
        JobTagUpdateRequest.initialize(this, jobTagId, jobTagData);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, jobTagId, jobTagData) { 
        obj['jobTagId'] = jobTagId;
        obj['jobTagData'] = jobTagData;
    }

    /**
     * Constructs a <code>JobTagUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobTagUpdateRequest} obj Optional instance to populate.
     * @return {module:model/JobTagUpdateRequest} The populated <code>JobTagUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobTagUpdateRequest();

            if (data.hasOwnProperty('jobTagId')) {
                obj['jobTagId'] = ApiClient.convertToType(data['jobTagId'], 'Number');
            }
            if (data.hasOwnProperty('jobTagData')) {
                obj['jobTagData'] = SaveJobTagRequest.constructFromObject(data['jobTagData']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobTagUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobTagUpdateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of JobTagUpdateRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // validate the optional field `jobTagData`
        if (data['jobTagData']) { // data not null
          SaveJobTagRequest.validateJSON(data['jobTagData']);
        }

        return true;
    }


}

JobTagUpdateRequest.RequiredProperties = ["jobTagId", "jobTagData"];

/**
 * @member {Number} jobTagId
 */
JobTagUpdateRequest.prototype['jobTagId'] = undefined;

/**
 * @member {module:model/SaveJobTagRequest} jobTagData
 */
JobTagUpdateRequest.prototype['jobTagData'] = undefined;






export default JobTagUpdateRequest;

